import React from "react";
import { useTranslation } from "react-i18next";

import Button from "beaktShared/components/CustomButtons/Button.js";
import { TIPOS_CONTRATO_DASHBOARD } from "./DashboardContratosService";

// BKT-1512: alterna os dashboards de contratos entre Contrato Renovação e Contrato Geral
export default function SeletorTipoContrato({ value, onChange, disabled }) {
  const { t } = useTranslation();
  return (
    <div role="group" aria-label={t("dashboard.contract_type")}>
      {TIPOS_CONTRATO_DASHBOARD.map(tipo => (
        <Button
          key={tipo.value}
          size="sm"
          round
          color={value === tipo.value ? "primary" : "transparent"}
          disabled={disabled}
          aria-pressed={value === tipo.value}
          onClick={() => value !== tipo.value && onChange(tipo.value)}
        >
          {t(tipo.label)}
        </Button>
      ))}
    </div>
  );
}
